import { render, staticRenderFns } from "./RiskConferenceWarning.vue?vue&type=template&id=0d036ca4&scoped=true"
import script from "./RiskConferenceWarning.vue?vue&type=script&lang=js"
export * from "./RiskConferenceWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d036ca4",
  null
  
)

export default component.exports